// Path: ./src/utils/analytics.ts
import * as amplitude from "@amplitude/analytics-browser";

/**
 *
 * @param event event name
 * @param eventProperties event property
 */
function callAmplitude(event: string, eventProperties?: any) {
  try {
    if (eventProperties) {
      amplitude.track(event, eventProperties);
    } else {
      amplitude.track(event);
    }
  } catch (error) {
    console.error("error", error);
  }
}
/**
 *
 * @param eventProperties pass key value pair
 */
export const view_createFlyer_page = function (eventProperties?: any) {
  callAmplitude("view_createFlyer_page", eventProperties);
};
